import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { featureKey } from './user.selectors';
import { reducer } from './user.reducer'
import { UserEffects } from './user.effects';
import { UserLoadedFailDialogComponent } from './components/dialogs/user-loaded-fail-dialog/user-loaded-fail-dialog.component';
import { HasRolePipe } from './pipes/has-role.pipe';
import { HasPermissionPipe } from './pipes/has-permission.pipe';
import { ThirdLibModule } from '../ui-kit/third-libs/third-lib.module';
import { TranslationsModule } from '../translations/translations.module';
@NgModule({
  declarations: [
    UserLoadedFailDialogComponent,
    HasRolePipe,
    HasPermissionPipe
  ],
  imports: [
    CommonModule,
    StoreModule.forFeature(featureKey, reducer),
    EffectsModule.forFeature([UserEffects]),
    TranslationsModule,
    ThirdLibModule
  ],
  exports: [
    HasRolePipe,
    HasPermissionPipe
  ],
  providers: [
    HasRolePipe,
    HasPermissionPipe
  ]
})
export class UserModule { }
